<template>
  <div class="row">
    <div class="col-md-12">
      <transition name="fade">
        <div class="alert alert-danger" v-if="show" >
          <button type="button" class="close" @click="show = false" v-focus>
            <i class="fa fa-times-circle" aria-hidden="true"></i>
          </button>
          <span>
            <b>{{ $t('cadastro.aviso.atencao') }}: </b> {{ $t('cadastro.aviso.atencao.a') }}</span>
        </div>      
      </transition>
      <transition name="fade">
        <div class="alert alert-danger" v-if="showNovo">
          <button type="button" class="close" @click="showNovo = false" v-focus>
            <i class="fa fa-times-circle" aria-hidden="true"></i>
          </button>
          <span>
            <b> {{ $t('cadastro.aviso.atencao') }}: </b>{{ $t('cadastro.aviso.atencao.b') }}</span>
        </div>
      </transition>
    </div>
    <div class="col-md-12 card">
      <transition name="fade">
        <div class="tela-edicao">
          <form method="#" action="#">
            <div class="card-header">
              <h4 class="card-title">
                {{ $t('cadastro.titulo.tipo.equipamento') }}
              </h4>
            </div>
            <div class="card-content">
              <div class="form-group">
                <div class="col-md-12"> <label>{{$t('cadastro.titulo.descricao')}}</label></div>               
                <input type="text" class="form-control disable" v-model="satusOrder">
                <input type="text" class="form-control disable" v-model="selectedId"> 
                <!-- Input / Botão limpar -->
                 <div class="input-group">
                  <input type="text" id="v-step-0" class="form-control upper col-md-11" :maxlength="max" v-model="selected" @input="upper($event)" ref="selected">
                  <span class="input-group-btn">
                    <button class="btn btn-secondary v-step-9" type="button" @click="clearButton"><i class="fa fa-eraser" aria-hidden="true"></i></button>
                  </span>
                </div>
                <div class="col-md-12">
                  <p class="number-characters">{{$t('cadastro.numero.caracteres')}}:</p>
                  <div class="number-characters-view" v-text="(max - selected.length)"></div>
                </div>  
              </div>
            </div>
            <div class="card-footer">
              <div class="form-group col-xs-12 col-sm-12 col-md-12" style="text-align:center" >
                <div class="col-xs-12 col-sm-6 col-md-6">
                  <button type="button" class="v-step-3 btn btn-wd btn-success btn-fill btn-margin" @click="showSwal('editar-tipo-equipamento')">
                    <span class="btn-label">
                        <i class="fa fa-check"></i>
                    </span>
                    {{$t('cadastro.btn.editar')}}
                  </button>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6">
                  <button type="button" class="v-step-1 btn btn-wd btn-info btn-fill btn-margin" @click="showSwal('novo-tipo-equipamento')">
                    <span class="btn-label">
                      <i class="fa fa-plus"></i>
                    </span>
                    {{$t('cadastro.btn.novo')}}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </transition>
       <!-- end card -->
      </div>
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">{{$t('quantidade-linhas-tabela')}}</div>
        </div>
        <div class="card-content row">
          <div class="col-xs-12 col-sm-6 col-md-6">
            <el-select
              class="select-default select-limit v-step-5"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="pull-right searchQuery v-step-6">
              <label>
                <input type="search" class="form-control input-sm search-input" :placeholder="$t('tabela.search')" v-model="searchQuery" aria-controls="datatables">
              </label>
            </div>
          </div>      
        <div class="col-sm-12 v-step-2 v-step-4 v-step-7 v-step-8" >
          <el-table ref="tabelaGeral" class="table-striped"
                    :data="queriedData"
                    @sort-change="ordem"                   
                    border
                    style="width: 100%">
            <!--   lista de equipamentos-->     
            <el-table-column v-for="column in tableColumns"
                             :sortable="column.sortable"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="$t(column.label)">
            </el-table-column>
             
            <el-table-column
              :min-width="70"
              fixed="right"
              :label="$t('cadastro.tipo.equipamento.tabela.acao')"
              >
              <template slot-scope="props">
                <a class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="handleEdit(props.$index, props.row)"><i class="ti-pencil-alt"></i></a>
                <a class="btn btn-simple btn-xs btn-danger btn-icon remove"  @click="handleDelete(props.$index, props.row)"><i class="ti-close"></i></a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--FIM TABELA-->
        <!--PAGINAÇÃO -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{$t('paginacao-showing')}} {{from + 1}} {{$t('paginacao-to')}} {{to}} {{$t('paginacao-of')}} {{total}} {{$t('paginacao-entries')}}</p>
        </div>
        <div class="col-sm-6 v-step-10">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total"
                        :searchQuery="this.searchQuery"
                        :order="this.satusOrder">
          </p-pagination>
        </div>
      <!--FIM PAGINAÇÃO -->
      </div>
    </div>
    <!--CONFIGURAÇÃO FUNÇÃO HELP -->
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :isFirst="tour.isFirst"
            :isLast="tour.isLast"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.01')}} </p>
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 1">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.02')}} </p>
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 2">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.03')}}<i class="btn btn-simple btn-xs btn-warning btn-icon edit ti-pencil-alt"></i> {{$t('helper.msg.cadastro.04')}}</p>
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 3">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.05')}}</p>
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 4">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.06')}}<i class="btn btn-simple btn-xs btn-danger btn-icon remove ti-close"></i> {{$t('helper.msg.cadastro.07')}}</p>
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 5">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.08')}}</p>
                <p class="helper-text">{{$t('helper.msg.cadastro.09')}}</p>                
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 6">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.10')}}</p>             
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 7">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.11')}}<i class="fa fa-sort-asc" aria-hidden="true"></i>{{$t('helper.msg.cadastro.12')}}</p>        
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 8">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.13')}}<i class="fa fa-sort-desc" aria-hidden="true"></i>{{$t('helper.msg.cadastro.14')}}</p>        
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 9">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.18')}}</p>        
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.nextStep" class="btn btn-primary"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </template>
            <template v-if="tour.currentStep === 10">
              <div slot="actions">
                <p class="helper-text">{{$t('helper.msg.cadastro.15')}}<i class="fa fa-angle-double-right" aria-hidden="true"></i>{{$t('helper.msg.cadastro.16')}}<i class="fa fa-angle-double-left" aria-hidden="true"></i></p>      
                <div @click="tour.stop" class="btn-fechar-help"><i class="fa fa-times-circle" aria-hidden="true"></i></div>
                <button @click="tour.previousStep" class="btn btn-primary"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button @click="tour.stop" class="btn btn-primary">{{$t('helper.msg.cadastro.17')}}</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>
<!-- JAVASCRIPT -->
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import { mapGetters } from 'vuex'
  import {TIPO_REQUEST, TIPO_DELETE, TIPO_CREATE, TIPO_UPDATE} from '../../../../store/actions/componentType'
  // import axios from 'axios'
  import AsyncComputed from 'vue-async-computed'

  const focus = {
    inserted (el) {
      el.focus()
    }
  }

  Vue.use(AsyncComputed)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default{
    directives: { focus },
    name: 'my-tour',
    components: {
      PPagination
    },
    asyncComputed: {
      ...mapGetters({
        tableData: 'tableData'
      }),
      async pagedData () {
        return this.tableData
      },
      async queriedData () {
        if (!this.searchQuery) {
          if (this.tableData && this.tableData[0].total > 1) {
            this.pagination.total = this.tableData[0].total
            return this.pagedData
          }
        }
        // PESQUISA
        if (this.searchQuery) {
          return this.tableData
        }
      },
      async to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      async from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      async total () {
        if (this.tableData && this.tableData[0].total > 0) {
          this.pagination.total = this.tableData[0].total
          return this.tableData[0].total
        }
      }
    },
    watch: {
      searchQuery (value) {
        let page = 1
        let limit = this.pagination.perPage
        let order = this.satusOrder
        if (this.searchQuery) {
          let search = this.searchQuery
          this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
        }
        if (this.searchQuery === '') {
          let search = ''
          this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
        }
      }
    },
    data () {
      return {
        steps: [
          {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            content: 'Help:'
          },
          {
            target: '.v-step-1',
            content: 'Help:'
          },
          {
            target: '.v-step-2',
            content: 'Help:'
          },
          {
            target: '.v-step-3',
            content: 'Help:'
          },
          {
            target: '.v-step-4',
            content: 'Help:'
          },
          {
            target: '.v-step-5',
            content: 'Help:'
          },
          {
            target: '.v-step-6',
            content: 'Help:'
          },
          {
            target: '.v-step-7',
            content: 'Help:'
          },
          {
            target: '.v-step-8',
            content: 'Help:'
          },
          {
            target: '.v-step-9',
            content: 'Help:'
          },
          {
            target: '.v-step-10',
            content: 'Help:'
          }
        ],
        max: 40,
        text: '',
        type: ['', 'info', 'success', 'warning', 'danger'],
        notifications: {
          topCenter: false
        },
        selected: '',
        selectedId: '',
        satusOrder: '',
        show: false,
        showNovo: false,
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['id', 'descricao'],
        tableColumns: [
          /* {
            prop: 'id',
            label: 'id.tabela.tipo.equipamento',
            minWidth: 30
          }, */
          {
            prop: 'descricao',
            sortable: 'custom',
            label: 'cadastro.tipo.equipamento.tabela.descricao',
            minWidth: 250
          }
        ]
      }
    },
    mounted () {
      let page = 1
      let limit = this.pagination.perPage
      let search = ''
      let order = 'ascending'
      this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
    },
    methods: {
      clearButton () {
        this.selected = ''
      },
      nextStep () {
        this.$tours['myTour'].nextStep()
      },
      showLastStep () {
        this.$tours['myTour'].currentStep = this.steps.length - 1
      },
      myCustomPreviousStepCallback (currentStep) {
        console.log('[Vue Tour] A custom previousStep callback has been called on step ' + (currentStep + 1))
      },
      myCustomNextStepCallback (currentStep) {
        console.log('[Vue Tour] A custom nextStep callback has been called on step ' + (currentStep + 1))

        if (currentStep === 1) {
          console.log('[Vue Tour] A custom nextStep callback has been called from step 2 to step 3')
        }
      },
      upper (e) {
        e.target.value = e.target.value.toUpperCase()
      },
      ordem (a) {
        this.satusOrder = a.order
        console.log(a)
        let page = 1
        let limit = this.pagination.perPage
        let search = ''
        let order = a.order
        this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
      },
      showSwal (type) {
        const { selected } = this
        const { selectedId } = this
        if (type === 'editar-tipo-equipamento') {
          if (selectedId === '' || selected === '') {
            this.show = true
            setTimeout(() => {
              this.show = false
            }, 5000)
            return false
          }
          // Alterar
          var sucessoAlterar = this.$t('cadastro.sweet.text.alterar.sucesso')
          var msgSucessoAlterar = this.$t('cadastro.sweet.text.alterar.sucesso.msg')
          var errorAlterar = this.$t('cadastro.sweet.text.erro.alterar')
          var msgErrorAlterar = this.$t('cadastro.sweet.text.erro.alterar.msg')
          swal({
            // title: 'Alterar a descrição do Tipo do Equipamento?',
            text: this.$t('cadastro.sweet.text.alterar'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Ok',
            buttonsStyling: false
          }).then((data) => {
            let descricao = selected.toUpperCase()
            this.$store.dispatch(TIPO_UPDATE, {descricao, selectedId})
            .then((res) => {
              if (res.status === 400) {
                swal({
                  title: errorAlterar,
                  text: msgErrorAlterar,
                  type: 'warning',
                  confirmButtonClass: 'btn btn-danger btn-fill',
                  buttonsStyling: false
                })
              } else if (res.status === 200) {
                swal({
                  title: sucessoAlterar,
                  text: msgSucessoAlterar,
                  type: 'success',
                  confirmButtonClass: 'btn btn-success btn-fill',
                  buttonsStyling: false
                })
                this.selected = ''
                this.selectedId = ''
                let page = this.pagination.currentPage
                let limit = this.pagination.perPage
                let search = ''
                let order = this.satusOrder
                this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
              }
            })
            .catch(error => {
              console.log(error)
              swal({
                title: errorAlterar,
                text: msgErrorAlterar,
                type: 'warning',
                confirmButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
              })
            })
          })
        } else if (type === 'novo-tipo-equipamento') {
          if (selected === '') {
            this.showNovo = true
            setTimeout(() => {
              this.showNovo = false
            }, 5000)
            return false
          }
          /*
          Exemplo de teste para Evandro
          swal({
            title: 'Alerta',
            text: 'Sem Conexão!!',
            timer: 5000,
            showConfirmButton: false
          })
          setTimeout(function () {
            // this.$router.go('/')
            window.location.reload()
          }, 3000)
          */
           // Novo
          var errorNovo = this.$t('cadastro.sweet.text.criar.erro')
          var msgErrorNovo = this.$t('cadastro.sweet.text.criar.erro.msg')
          var sucessoNovo = this.$t('cadastro.sweet.text.criar.salvo')
          var msgSucessoNovo = this.$t('cadastro.sweet.text.criar.salvo.msg.geral')
          swal({
            // title: 'Criar novo Tipo de Equipamento?',
            text: this.$t('cadastro.sweet.text.criar'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Ok',
            buttonsStyling: false
          }).then((data) => {
            let descricao = selected.toUpperCase()
            this.$store.dispatch(TIPO_CREATE, { descricao })
            .then((res) => {
              if (res.status === 400) {
                swal({
                  title: errorNovo,
                  text: msgErrorNovo,
                  type: 'warning',
                  confirmButtonClass: 'btn btn-danger btn-fill',
                  buttonsStyling: false
                })
              } else if (res.status === 200) {
                swal({
                  title: sucessoNovo,
                  text: msgSucessoNovo,
                  type: 'success',
                  confirmButtonClass: 'btn btn-success btn-fill',
                  buttonsStyling: false
                })
                this.selected = ''
                let page = 1
                let limit = this.pagination.perPage
                let search = ''
                let order = this.satusOrder
                this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
              }
            })
            .catch(error => {
              console.log(error)
              swal({
                title: errorNovo,
                text: msgErrorNovo,
                type: 'warning',
                confirmButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
              })
            })
          })
        }
      },
      handleEdit (index, row) {
        this.selected = row.descricao
        this.selectedId = row.id
        this.$refs.selected.focus()
      },
      handleDelete (index, row) {
        let selectedId = row.id
        let descricao = row.descricao
        var errorExcluir = this.$t('cadastro.sweet.text.excluir.erro')
        var msgErrorExcluir = this.$t('cadastro.sweet.text.excluir.erro.msg')
        var sucessoExcluir = this.$t('cadastro.sweet.text.excluir.sucesso')
        var msgSucessoExcluir = this.$t('cadastro.sweet.text.excluir.sucesso.msg')
        swal({
          // title: 'Criar novo Tipo de Equipamento?',
          text: this.$t('cadastro.sweet.text.excluir'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Ok',
          buttonsStyling: false
        }).then((data) => {
          this.$store.dispatch(TIPO_DELETE, {descricao, selectedId})
          .then((res) => {
            if (res.status === 400) {
              swal({
                title: errorExcluir,
                text: msgErrorExcluir,
                type: 'warning',
                confirmButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
              })
            } else if (res.status === 200) {
              swal({
                title: sucessoExcluir,
                text: msgSucessoExcluir,
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              })
              this.selected = ''
              let page = 1
              let limit = this.pagination.perPage
              let search = ''
              let order = this.satusOrder
              this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
            }
          })
          .catch(error => {
            console.log(error)
            swal({
              title: errorExcluir,
              text: msgErrorExcluir,
              type: 'warning',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            })
          })
        })
      }
    }
  }
</script>
<style>
.form-group{
  height: 65px;
}
.btn, .navbar .navbar-nav > li > a.btn{
  border-color: #eeeceb!important;
}
.select-limit{
  width: 20%;
}
.el-input__icon{
  line-height: 22px;
}

.card .card-footer{
  min-height: 120px;
}
.btn-margin{
  margin:5px 0px;
}
.float-right{
  text-align:right;
  margin-right: 5px;
  cursor: pointer;
}
.card .card-header{
  padding-top: 10px;
}
.acao-table{
  text-align: center;
}
.disable{
  display: none;
}
.upper{
  text-transform: uppercase;
}
.search-input{
  text-transform: uppercase;
}
.number-characters{
  float:left;
  font-size:12px;
  margin-top: 2px;
  color: #9A9A9A;
}
.number-characters-view{
  float:left;
  width: 30px;
  margin-top: 2px;
  font-size:12px;
  margin-left: 5px;
  color: #9A9A9A;
}
.pull-right{
  margin-top: 5px;
  float: left!important;
}
@media (min-width: 765px){
  .card .card-footer{
    min-height: 55px!important;
  }
  .pull-right{
    margin-top: 5px;
    float: right!important;
  }
}
.btn-fechar-help{
  padding-right: 0px;
}

.helper-text{
  font-size: 13px;
  text-align: justify;
}

.v-step{
  z-index: 999;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Crud/ComponentType.vue